// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_invocation_search.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTarget
 */
export interface PasswordPushInvocationTarget {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 2
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 4
     */
    status: PasswordPushInvocationTaskStatus;
    /**
     * @generated from protobuf field: string error_message = 5
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetStateRef
 */
export interface PasswordPushInvocationTargetStateRef {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetState
 */
export interface PasswordPushInvocationTargetState {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: string app_id = 2
     */
    appId: string;
    /**
     * @generated from protobuf field: string connector_id = 3
     */
    connectorId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4
     */
    appUserId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 5
     */
    status: PasswordPushInvocationTaskStatus;
    /**
     * @generated from protobuf field: string error_message = 6
     */
    errorMessage: string;
    /**
     * @generated from protobuf field: int32 retry_attempts = 7
     */
    retryAttempts: number;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 8
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 9
     */
    updatedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationRef
 */
export interface PasswordPushInvocationRef {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocation
 */
export interface PasswordPushInvocation {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string user_id = 3
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationStatus status = 5
     */
    status: PasswordPushInvocationStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 6
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 7
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: string error_message = 8
     */
    errorMessage: string;
}
/**
 * The supported paths are 'user_id', 'password_push_flow_id'
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationExpandMask
 */
export interface PasswordPushInvocationExpandMask {
    /**
     * An array of paths to be expanded in the response.
     *
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
// ====== Search ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest
 */
export interface PasswordPushInvocationSearchServiceRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationRef refs = 4
     */
    refs: PasswordPushInvocationRef[];
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationStatus statuses = 5
     */
    statuses: PasswordPushInvocationStatus[];
    /**
     * @generated from protobuf field: repeated string user_ids = 6
     */
    userIds: string[];
    /**
     * @generated from protobuf field: string password_push_flow_id = 7
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocationExpandMask expand_mask = 8
     */
    expandMask?: PasswordPushInvocationExpandMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse
 */
export interface PasswordPushInvocationSearchServiceResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request
     *
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationView list = 1
     */
    list: PasswordPushInvocationView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
// ====== Get Latest Password Push Invocation For User ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest
 */
export interface PasswordPushInvocationSearchServiceGetLatestForUserRequest {
    /**
     * @generated from protobuf field: string user_id = 1
     */
    userId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2
     */
    passwordPushFlowId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse
 */
export interface PasswordPushInvocationSearchServiceGetLatestForUserResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocation invocation = 1
     */
    invocation?: PasswordPushInvocation;
}
// ====== Get Target States For Invocation ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest
 */
export interface PasswordPushInvocationSearchServiceGetTargetStatesRequest {
    /**
     * @generated from protobuf field: string password_push_invocation_id = 1
     */
    passwordPushInvocationId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationTargetStateRef refs = 4
     */
    refs: PasswordPushInvocationTargetStateRef[];
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse
 */
export interface PasswordPushInvocationSearchServiceGetTargetStatesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.password_push.v1.PasswordPushInvocationTargetState list = 1
     */
    list: PasswordPushInvocationTargetState[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
// ====== View ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushInvocationView
 */
export interface PasswordPushInvocationView {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushInvocation invocation = 1
     */
    invocation?: PasswordPushInvocation;
    /**
     * JSONPATH expression indicating the location of the User object in the expanded array
     *
     * @generated from protobuf field: string user_path = 2
     */
    userPath: string;
    /**
     * JSONPATH expression indicating the location of the PasswordPushFlow object in the expanded array
     *
     * @generated from protobuf field: string password_push_flow_path = 3
     */
    passwordPushFlowPath: string;
}
// ====== Messages ======

/**
 * @generated from protobuf enum c1.api.password_push.v1.PasswordPushInvocationTaskStatus
 */
export enum PasswordPushInvocationTaskStatus {
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_TASK_STATUS_ERROR = 2;
     */
    ERROR = 2
}
/**
 * @generated from protobuf enum c1.api.password_push.v1.PasswordPushInvocationStatus
 */
export enum PasswordPushInvocationStatus {
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_RUNNING = 1;
     */
    RUNNING = 1,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_SUCCESS = 2;
     */
    SUCCESS = 2,
    /**
     * @generated from protobuf enum value: PASSWORD_PUSH_INVOCATION_STATUS_ERROR = 3;
     */
    ERROR = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTarget$Type extends MessageType<PasswordPushInvocationTarget> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTarget", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationTaskStatus", PasswordPushInvocationTaskStatus, "PASSWORD_PUSH_INVOCATION_TASK_STATUS_"] },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationTarget>): PasswordPushInvocationTarget {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.connectorId = "";
        message.appUserId = "";
        message.status = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationTarget>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationTarget): PasswordPushInvocationTarget {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 2:
                    message.connectorId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushInvocationTaskStatus status */ 4:
                    message.status = reader.int32();
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationTarget, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 2; */
        if (message.connectorId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.connectorId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 4; */
        if (message.status !== 0)
            writer.tag(4, WireType.Varint).int32(message.status);
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTarget
 */
export const PasswordPushInvocationTarget = new PasswordPushInvocationTarget$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTargetStateRef$Type extends MessageType<PasswordPushInvocationTargetStateRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTargetStateRef", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationTargetStateRef>): PasswordPushInvocationTargetStateRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushInvocationId = "";
        message.appId = "";
        message.connectorId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationTargetStateRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationTargetStateRef): PasswordPushInvocationTargetStateRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_invocation_id */ 1:
                    message.passwordPushInvocationId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationTargetStateRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_invocation_id = 1; */
        if (message.passwordPushInvocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushInvocationId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetStateRef
 */
export const PasswordPushInvocationTargetStateRef = new PasswordPushInvocationTargetStateRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationTargetState$Type extends MessageType<PasswordPushInvocationTargetState> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationTargetState", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationTaskStatus", PasswordPushInvocationTaskStatus, "PASSWORD_PUSH_INVOCATION_TASK_STATUS_"] },
            { no: 6, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "retry_attempts", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 9, name: "updated_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationTargetState>): PasswordPushInvocationTargetState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushInvocationId = "";
        message.appId = "";
        message.connectorId = "";
        message.appUserId = "";
        message.status = 0;
        message.errorMessage = "";
        message.retryAttempts = 0;
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationTargetState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationTargetState): PasswordPushInvocationTargetState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_invocation_id */ 1:
                    message.passwordPushInvocationId = reader.string();
                    break;
                case /* string app_id */ 2:
                    message.appId = reader.string();
                    break;
                case /* string connector_id */ 3:
                    message.connectorId = reader.string();
                    break;
                case /* string app_user_id */ 4:
                    message.appUserId = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushInvocationTaskStatus status */ 5:
                    message.status = reader.int32();
                    break;
                case /* string error_message */ 6:
                    message.errorMessage = reader.string();
                    break;
                case /* int32 retry_attempts */ 7:
                    message.retryAttempts = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 8:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 9:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationTargetState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_invocation_id = 1; */
        if (message.passwordPushInvocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushInvocationId);
        /* string app_id = 2; */
        if (message.appId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appId);
        /* string connector_id = 3; */
        if (message.connectorId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.connectorId);
        /* string app_user_id = 4; */
        if (message.appUserId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appUserId);
        /* c1.api.password_push.v1.PasswordPushInvocationTaskStatus status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* string error_message = 6; */
        if (message.errorMessage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorMessage);
        /* int32 retry_attempts = 7; */
        if (message.retryAttempts !== 0)
            writer.tag(7, WireType.Varint).int32(message.retryAttempts);
        /* google.protobuf.Timestamp created_at = 8; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 9; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationTargetState
 */
export const PasswordPushInvocationTargetState = new PasswordPushInvocationTargetState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationRef$Type extends MessageType<PasswordPushInvocationRef> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationRef>): PasswordPushInvocationRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationRef): PasswordPushInvocationRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationRef
 */
export const PasswordPushInvocationRef = new PasswordPushInvocationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocation$Type extends MessageType<PasswordPushInvocation> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocation", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "enum", T: () => ["c1.api.password_push.v1.PasswordPushInvocationStatus", PasswordPushInvocationStatus, "PASSWORD_PUSH_INVOCATION_STATUS_"] },
            { no: 6, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocation>): PasswordPushInvocation {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.passwordPushFlowId = "";
        message.userId = "";
        message.status = 0;
        message.errorMessage = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocation): PasswordPushInvocation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string password_push_flow_id */ 2:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string user_id */ 3:
                    message.userId = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushInvocationStatus status */ 5:
                    message.status = reader.int32();
                    break;
                case /* google.protobuf.Timestamp created_at */ 6:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 7:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* string error_message */ 8:
                    message.errorMessage = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string password_push_flow_id = 2; */
        if (message.passwordPushFlowId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string user_id = 3; */
        if (message.userId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userId);
        /* c1.api.password_push.v1.PasswordPushInvocationStatus status = 5; */
        if (message.status !== 0)
            writer.tag(5, WireType.Varint).int32(message.status);
        /* google.protobuf.Timestamp created_at = 6; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 7; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string error_message = 8; */
        if (message.errorMessage !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.errorMessage);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocation
 */
export const PasswordPushInvocation = new PasswordPushInvocation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationExpandMask$Type extends MessageType<PasswordPushInvocationExpandMask> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "user_id", "password_push_flow_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationExpandMask>): PasswordPushInvocationExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationExpandMask): PasswordPushInvocationExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationExpandMask
 */
export const PasswordPushInvocationExpandMask = new PasswordPushInvocationExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceRequest$Type extends MessageType<PasswordPushInvocationSearchServiceRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 5, name: "statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.password_push.v1.PasswordPushInvocationStatus", PasswordPushInvocationStatus, "PASSWORD_PUSH_INVOCATION_STATUS_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { enum: { definedOnly: true } } } } } },
            { no: 6, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "expand_mask", kind: "message", T: () => PasswordPushInvocationExpandMask }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceRequest>): PasswordPushInvocationSearchServiceRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        message.statuses = [];
        message.userIds = [];
        message.passwordPushFlowId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceRequest): PasswordPushInvocationSearchServiceRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated c1.api.password_push.v1.PasswordPushInvocationRef refs */ 4:
                    message.refs.push(PasswordPushInvocationRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.password_push.v1.PasswordPushInvocationStatus statuses */ 5:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.statuses.push(reader.int32());
                    else
                        message.statuses.push(reader.int32());
                    break;
                case /* repeated string user_ids */ 6:
                    message.userIds.push(reader.string());
                    break;
                case /* string password_push_flow_id */ 7:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushInvocationExpandMask expand_mask */ 8:
                    message.expandMask = PasswordPushInvocationExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated c1.api.password_push.v1.PasswordPushInvocationRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            PasswordPushInvocationRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.password_push.v1.PasswordPushInvocationStatus statuses = 5; */
        if (message.statuses.length) {
            writer.tag(5, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.statuses.length; i++)
                writer.int32(message.statuses[i]);
            writer.join();
        }
        /* repeated string user_ids = 6; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.userIds[i]);
        /* string password_push_flow_id = 7; */
        if (message.passwordPushFlowId !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* c1.api.password_push.v1.PasswordPushInvocationExpandMask expand_mask = 8; */
        if (message.expandMask)
            PasswordPushInvocationExpandMask.internalBinaryWrite(message.expandMask, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceRequest
 */
export const PasswordPushInvocationSearchServiceRequest = new PasswordPushInvocationSearchServiceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceResponse$Type extends MessageType<PasswordPushInvocationSearchServiceResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceResponse>): PasswordPushInvocationSearchServiceResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceResponse): PasswordPushInvocationSearchServiceResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushInvocationView list */ 1:
                    message.list.push(PasswordPushInvocationView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushInvocationView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushInvocationView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceResponse
 */
export const PasswordPushInvocationSearchServiceResponse = new PasswordPushInvocationSearchServiceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetLatestForUserRequest$Type extends MessageType<PasswordPushInvocationSearchServiceGetLatestForUserRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceGetLatestForUserRequest>): PasswordPushInvocationSearchServiceGetLatestForUserRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userId = "";
        message.passwordPushFlowId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceGetLatestForUserRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceGetLatestForUserRequest): PasswordPushInvocationSearchServiceGetLatestForUserRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_id */ 1:
                    message.userId = reader.string();
                    break;
                case /* string password_push_flow_id */ 2:
                    message.passwordPushFlowId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceGetLatestForUserRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string user_id = 1; */
        if (message.userId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userId);
        /* string password_push_flow_id = 2; */
        if (message.passwordPushFlowId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.passwordPushFlowId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserRequest
 */
export const PasswordPushInvocationSearchServiceGetLatestForUserRequest = new PasswordPushInvocationSearchServiceGetLatestForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetLatestForUserResponse$Type extends MessageType<PasswordPushInvocationSearchServiceGetLatestForUserResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse", [
            { no: 1, name: "invocation", kind: "message", T: () => PasswordPushInvocation }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceGetLatestForUserResponse>): PasswordPushInvocationSearchServiceGetLatestForUserResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceGetLatestForUserResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceGetLatestForUserResponse): PasswordPushInvocationSearchServiceGetLatestForUserResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushInvocation invocation */ 1:
                    message.invocation = PasswordPushInvocation.internalBinaryRead(reader, reader.uint32(), options, message.invocation);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceGetLatestForUserResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushInvocation invocation = 1; */
        if (message.invocation)
            PasswordPushInvocation.internalBinaryWrite(message.invocation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetLatestForUserResponse
 */
export const PasswordPushInvocationSearchServiceGetLatestForUserResponse = new PasswordPushInvocationSearchServiceGetLatestForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetTargetStatesRequest$Type extends MessageType<PasswordPushInvocationSearchServiceGetTargetStatesRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest", [
            { no: 1, name: "password_push_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationTargetStateRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceGetTargetStatesRequest>): PasswordPushInvocationSearchServiceGetTargetStatesRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.passwordPushInvocationId = "";
        message.pageSize = 0;
        message.pageToken = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceGetTargetStatesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceGetTargetStatesRequest): PasswordPushInvocationSearchServiceGetTargetStatesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string password_push_invocation_id */ 1:
                    message.passwordPushInvocationId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* repeated c1.api.password_push.v1.PasswordPushInvocationTargetStateRef refs */ 4:
                    message.refs.push(PasswordPushInvocationTargetStateRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceGetTargetStatesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string password_push_invocation_id = 1; */
        if (message.passwordPushInvocationId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.passwordPushInvocationId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* repeated c1.api.password_push.v1.PasswordPushInvocationTargetStateRef refs = 4; */
        for (let i = 0; i < message.refs.length; i++)
            PasswordPushInvocationTargetStateRef.internalBinaryWrite(message.refs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesRequest
 */
export const PasswordPushInvocationSearchServiceGetTargetStatesRequest = new PasswordPushInvocationSearchServiceGetTargetStatesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationSearchServiceGetTargetStatesResponse$Type extends MessageType<PasswordPushInvocationSearchServiceGetTargetStatesResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PasswordPushInvocationTargetState },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationSearchServiceGetTargetStatesResponse>): PasswordPushInvocationSearchServiceGetTargetStatesResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationSearchServiceGetTargetStatesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationSearchServiceGetTargetStatesResponse): PasswordPushInvocationSearchServiceGetTargetStatesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.password_push.v1.PasswordPushInvocationTargetState list */ 1:
                    message.list.push(PasswordPushInvocationTargetState.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationSearchServiceGetTargetStatesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.password_push.v1.PasswordPushInvocationTargetState list = 1; */
        for (let i = 0; i < message.list.length; i++)
            PasswordPushInvocationTargetState.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationSearchServiceGetTargetStatesResponse
 */
export const PasswordPushInvocationSearchServiceGetTargetStatesResponse = new PasswordPushInvocationSearchServiceGetTargetStatesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushInvocationView$Type extends MessageType<PasswordPushInvocationView> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushInvocationView", [
            { no: 1, name: "invocation", kind: "message", T: () => PasswordPushInvocation },
            { no: 2, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushInvocationView>): PasswordPushInvocationView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.userPath = "";
        message.passwordPushFlowPath = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushInvocationView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushInvocationView): PasswordPushInvocationView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushInvocation invocation */ 1:
                    message.invocation = PasswordPushInvocation.internalBinaryRead(reader, reader.uint32(), options, message.invocation);
                    break;
                case /* string user_path */ 2:
                    message.userPath = reader.string();
                    break;
                case /* string password_push_flow_path */ 3:
                    message.passwordPushFlowPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushInvocationView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushInvocation invocation = 1; */
        if (message.invocation)
            PasswordPushInvocation.internalBinaryWrite(message.invocation, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string user_path = 2; */
        if (message.userPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userPath);
        /* string password_push_flow_path = 3; */
        if (message.passwordPushFlowPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.passwordPushFlowPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushInvocationView
 */
export const PasswordPushInvocationView = new PasswordPushInvocationView$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushInvocationSearchService
 */
export const PasswordPushInvocationSearchService = new ServiceType("c1.api.password_push.v1.PasswordPushInvocationSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceRequest, O: PasswordPushInvocationSearchServiceResponse },
    { name: "GetLatestForUser", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceGetLatestForUserRequest, O: PasswordPushInvocationSearchServiceGetLatestForUserResponse },
    { name: "GetTargetStates", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushInvocationSearchServiceGetTargetStatesRequest, O: PasswordPushInvocationSearchServiceGetTargetStatesResponse }
]);
